import * as React from 'react';

interface SettingsFooterProps {
  children: React.ReactNode;
}

export default function SettingsFooter({ children }: SettingsFooterProps) {
  return (
    <footer>
      <div className="flex flex-col px-6 py-5 border-t border-gray-200 dark:border-gray-700/60">
        <div className="flex self-end">{children}</div>
      </div>
    </footer>
  );
}
